import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import { X } from 'lucide-react';

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà accepté/fermé la bannière
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Afficher la bannière après un court délai
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleClose = () => {
    localStorage.setItem('cookieConsent', 'dismissed');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 animate-in slide-in-from-bottom duration-500"
      style={{ backgroundColor: 'rgba(255, 255, 255, 0.98)' }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 mt-1">
                <svg
                  className="w-6 h-6"
                  style={{ color: '#C9793A' }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-base font-semibold mb-2" style={{ color: '#1d1d1f' }}>
                  🍪 Utilisation des cookies
                </h3>
                <p className="text-sm leading-relaxed" style={{ color: '#6e6e73' }}>
                  Ce site utilise uniquement des <strong>cookies strictement nécessaires</strong> à son fonctionnement (navigation, sécurité). 
                  Aucun cookie analytique, publicitaire ou de réseaux sociaux n'est déposé. 
                  Pour en savoir plus, consultez notre{' '}
                  <Link
                    to={ROUTE_PATHS.COOKIES}
                    className="underline hover:no-underline transition-all"
                    style={{ color: '#C9793A' }}
                  >
                    Politique de Cookies
                  </Link>
                  {' '}et notre{' '}
                  <Link
                    to={ROUTE_PATHS.CONFIDENTIALITE}
                    className="underline hover:no-underline transition-all"
                    style={{ color: '#C9793A' }}
                  >
                    Politique de Confidentialité
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleAccept}
              className="px-6 py-3 text-sm font-semibold rounded-full transition-all duration-300 hover:scale-105 shadow-md"
              style={{
                backgroundColor: '#C9793A',
                color: '#ffffff'
              }}
            >
              J'ai compris
            </button>
            <button
              onClick={handleClose}
              className="p-2 rounded-full transition-all duration-300 hover:bg-gray-100"
              style={{ color: '#6e6e73' }}
              aria-label="Fermer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Bordure supérieure */}
      <div
        className="absolute top-0 left-0 right-0 h-1"
        style={{
          background: 'linear-gradient(90deg, #C9793A 0%, #E8A050 100%)'
        }}
      />
    </div>
  );
}
